module.exports = __webpack_public_path__ + "img/login_xl_bg.dbde2d16.png";